import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { businessCategory} from "@/services/api/cresivoxServer";


import { iBusinessCategoryDTO, REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

  export const getBusinessCategoryList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getBusinessCategoryList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
		  const response = await businessCategory.getBusinessCategoryList();
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const deleteBusinessCategory = createAsyncThunk<
iGenericResponse<any | null> | null,
{id:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteBusinessCategory"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({id}, {rejectWithValue}) => {
	try {
		const response = await businessCategory.deleteBusinessCategory(id);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const createBusinessCategory = createAsyncThunk<
iGenericResponse<any | null> | null,
iBusinessCategoryDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("createBusinessCategory"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await businessCategory.createBusinessCategory(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_CREATED: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


